import _ from 'lodash';

export default function EquipmentFiltersSummaryDirective() {
  return {
    restrict: 'E',
    template: require('./equipment-filters-summary.html'),
    scope: {
      facets: '=',
      tags: '=',
      tagFilters: '='
    },
    controller: EquipmentFiltersSummaryController
  };

  function EquipmentFiltersSummaryController($scope, $filter, gettextCatalog, TimezoneService) {
    'ngInject';
    $scope.numFilters = $scope.filters;

    $scope.deselectFacets = function(facets, key) {
      if (key === 'lastSeen') {
        $scope.facets.lastSeen = [];
      }
      _.forEach(facets, function(e) {
        e._selected = false;
      });

      $scope.facets = angular.copy($scope.facets);
      $scope.facets._updatedBy = $scope.$id;

      $scope.$emit('map-filter-update');
    };

    $scope.deselectTags = function(tagFilters) {
      $scope.tagFilters = {};
    };

    $scope.selectedTagFilters = function() {
      _.forEach($scope.tagFilters, function(e) {
        if (!e) return false;
        return e._selected;
      });
    };

    $scope.tagsLength = function() {
      if (!$scope.tagFilters) return 0;

      return Object.keys($scope.tagFilters).length;
    };

    $scope.selectedFacets = function(facet) {
      return _.filter(facet, function(e) {
        if (!e) return false;
        return e._selected;
      });
    };

    $scope.attrOutput = function(value, key) {
      if (typeof value !== 'object') {
        return value;
      } else {
        if (value.hasOwnProperty('any')) {
          return gettextCatalog.getString('(any)');
        }
        var output = '';
        if (!$scope.tags) {
          return value;
        }
        let tag;
        for (var i = 0; i < $scope.tags.length; i++) {
          if ($scope.tags[i].key === key) {
            tag = $scope.tags[i];
            break;
          }
        }
        if (!tag) {
          return value;
        }
        if (Array.isArray(value)) {
          let val = value[0];
          var output = null !== val && typeof val === 'object' ? val.text : val;
          for (var i = 1; i < value.length; i++) {
            val = value[i];
            val = null !== val && typeof val === 'object' ? val.text : val;
            output += ' <i>' + gettextCatalog.getString('OR') + '</i> ' + val;
          }
          return output;
        }
        switch (tag.dataType) {
          case 'Date':
            if (value.hasOwnProperty('min')) {
              if (!value.hasOwnProperty('max')) {
                output += gettextCatalog.getString('({{min}} or later)', {
                  min: $filter('date')(value.min, 'MMMM d, y')
                });
              } else {
                output += gettextCatalog.getString('from {{min}} to ', {
                  min: $filter('date')(value.min, 'MMMM d, y')
                });
              }
            }
            if (value.hasOwnProperty('max')) {
              if (!value.hasOwnProperty('min')) {
                output += gettextCatalog.getString('({{max}} or earlier)', {
                  max: $filter('date')(value.max, 'MMMM d, y')
                });
              } else {
                output += $filter('date')(value.max, 'MMMM d, y');
              }
            }
            return output;
            break;
          case 'Datetime':
            if (value.hasOwnProperty('min')) {
              let min = angular.copy(value.min);
              min = min.replace(/\\/g, '').toUpperCase();
              min = new Date(
                new Date(min).getTime() +
                  new Date(min).getTimezoneOffset() * 60000 +
                  TimezoneService.getUserTimezoneOffset(new Date(min)) * 60000
              );
              if (!value.hasOwnProperty('max')) {
                output += gettextCatalog.getString('({{min}} or later)', {
                  min: $filter('date')(min, 'MMMM d, y h:mm:ss a')
                });
              } else {
                output += gettextCatalog.getString('from {{min}} to ', {
                  min: $filter('date')(min, 'MMMM d, y h:mm:ss a')
                });
              }
            }
            if (value.hasOwnProperty('max')) {
              let max = angular.copy(value.max);
              max = max.replace(/\\/g, '').toUpperCase();
              max = new Date(
                new Date(max).getTime() -
                  new Date(max).getTimezoneOffset() * 60000 -
                  TimezoneService.getUserTimezoneOffset(new Date(max)) * 60000
              );
              if (!value.hasOwnProperty('min')) {
                output += gettextCatalog.getString('({{max}} or earlier)', {
                  max: $filter('date')(max, 'MMMM d, y h:mm:ss a')
                });
              } else {
                output += $filter('date')(max, 'MMMM d, y h:mm:ss a');
              }
            }
            return output;
            break;
          default:
            return value;
            break;
        }
      }
    };

    function updateSummary() {
      $scope.bubbles = [];

      _.forEach($scope.facets, function(val, key) {
        _.forEach(val, function(item, index) {
          if (item._selected && item.name) {
            $scope.bubbles.push({
              label: key,
              value: item.name //todo translate
            });
          }
        });
      });
    }
  }
}
